import useHasResponses from './useHasResponses'

// Is er op dit meetmoment al ingevuld? Een dunne laag over useHasResponses,
// dat dezelfde ja/nee-vraag ook per onderzoek en per vraag stelt.
//
// AI-CONTEXT: See docs/patterns.md#hook-firestore-custom

/**
 * @param {string} momentID - `MeasureMoments.ID`. Leeg = niet opvragen.
 * @returns {boolean|null} True/false zodra bekend, null zolang het antwoord
 *   nog niet binnen is (dan hoort de UI niets te beweren).
 */
const useMomentHasResponses = (momentID) => useHasResponses('MomentID', momentID)

export default useMomentHasResponses
